import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const FinalPublishSuccessModal = ({ show, onHide, finalPublishSuccessMessage }) => (
  <Modal
    show={show}
    onHide={onHide}
    backdrop="static"
    keyboard={false}
    dialogClassName='checkerModal'
  >
    <Modal.Header closeButton>
      <Modal.Title>Publish Success</Modal.Title>
    </Modal.Header>
    <Modal.Body>{finalPublishSuccessMessage}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={() => {
        onHide();
        window.location.reload();
      }}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export default FinalPublishSuccessModal;
